import React, { useState, forwardRef } from 'react';
import styled, { css }  from 'styled-components';
import { Link, withStyles, ListItem, ListItemText, Button } from '@material-ui/core';
import {CartCountBadge} from '../../components/badge/MyCartBadge'
import colors from '../../libs/colors';
import images from '../../assets';
import { MediaQuery } from '../Common';
const PCTopBar = styled.div`
  height: 100px;
  background-color: white;
  display: flex;
  align-items: center;
  padding-right: 17px;
  border-bottom-style: solid;
  border-bottom-color: #cccccc;
  border-bottom-width: 1px;
`;

const GNBTopBar = styled.div`
  height: 60px;
  background-color: white;
  display: flex;
  align-items: center;
  border-bottom-style: solid;
  border-bottom-color: #cccccc;
  border-bottom-width: 1px;
`;

export const TopBar = ({ children, ...props }) => {
  return (
    <>
      <MediaQuery min={1424}>
        <PCTopBar {...props}>{children}</PCTopBar>
      </MediaQuery>
      <MediaQuery max={1423}>
        <GNBTopBar {...props}>{children}</GNBTopBar>
      </MediaQuery>
    </>
  );
};

const cover = {
  position: 'fixed',
  top: '0px',
  right: '0px',
  bottom: '0px',
  left: '0px',
  zIndex: 9,
};

const LangItem = styled.div`
  display: flex;
  font-family: 'NSCJKrR';
  font-fize: 14px;
  color: 'black';
  line-height: 40px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
`;

const languagebutton = {
  fontFamily: 'SHSNeoR',
  fontSize: 14,
  display: 'flex',
  alignItems: 'center',
  paddingBottom: 5,
  paddingRight: 10,
  paddingLeft: 10,
  width: 150,
  justifyContent: 'space-between',
  borderBottomStyle: 'solid',
  borderBottomWidth: 1,
};



export const LanguageBtn = ({ onChange, value, active = false, bottom = true, ...props }) => {
  const [showmenu, setShowmenu] = useState('');
  const substyle = bottom ? { top: 40 } : { bottom: 40 };
  const getCurLang = (val) => {
    if (val === 'kr') {
      if(window.innerWidth < 1524 && window.innerWidth > 1224 ){
        return '한국어(￦)';
      }else{
        return '한국어-KRW(￦)';
      }
    } else if (val === 'en') {
      if(window.innerWidth < 1524 && window.innerWidth > 1224 ){
        return 'English($)';
      }else{
        return 'English-USD($)';
      }
      
    } else if (val === 'ur') {
      if(window.innerWidth < 1524 && window.innerWidth > 1224 ){
        return 'English(€)';
      }else{
        return 'English-EUR(€)';
      }
    }
  };
  let totalWidth;
  if(window.innerWidth < 1524 && window.innerWidth > 1224 ){
    totalWidth = 140;
  }

  
  return (
    <>
      <Button
        onClick={() => {
          console.log(value);
          setShowmenu(value);
        }}
        style={{ paddingRight: '20px', width: totalWidth}}
        // {...props}
      >
        <div
          style={{
            ...languagebutton,
            fontFamily: 'NSCJKrR',
            color: Boolean(showmenu) || active ? colors.active : 'black',
            borderBottomColor: Boolean(showmenu) || active ? colors.active : colors.border,
          }}
        >
          {getCurLang(value)}
          <img
            alt=""
            src={Boolean(showmenu) || active ? images.expandmore_act : images.expandmore_nor}
            style={expendIcon}
          />
        </div>
      </Button>
      {Boolean(showmenu) && (
        <div
          style={cover}
          onClick={() => {
            setShowmenu('');
          }}
        />
      )}
      {Boolean(showmenu) && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            backgroundColor: 'white',
            border: '1px solid #eeeeee',
            width: '100%',
            zIndex: 99,
            ...substyle,
          }}
        >
          <div style={{ margin: '0px 20px', zIndex: 99 }}>
            <LangItem
              style={{ color: showmenu === 'kr' ? '#ff8a06' : 'black' }}
              onMouseEnter={() => {
                setShowmenu('kr');
              }}
              onClick={() => {
                onChange('kr');
                setShowmenu('');
              }}
            >
              {getCurLang('kr')}
            </LangItem>
            <LangItem
              style={{ color: showmenu === 'en' ? '#ff8a06' : 'black' }}
              onMouseEnter={() => {
                setShowmenu('en');
              }}
              onClick={() => {
                onChange('en');
                setShowmenu('');
              }}
            >
             {getCurLang('en')}
            </LangItem>
            <LangItem
              style={{ color: showmenu === 'ur' ? '#ff8a06' : 'black' }}
              onMouseEnter={() => {
                setShowmenu('ur');
              }}
              onClick={() => {
                onChange('ur');
                setShowmenu('');
              }}
            >
             {getCurLang('ur')}
            </LangItem>
          </div>
        </div>
      )}
    </>
  );
};

export const TopBarList = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  /* z-index:99999; */
`;

const CusLink = withStyles({
  root: {
    display: 'flex',
    paddingLeft: 25,
    paddingRight: 25,
    alignItems: 'center',
  },
})(Link);

const CusLinkMedium = withStyles({
  root: {
    display: 'flex',
    paddingLeft: 15,
    paddingRight: 15,
    alignItems: 'center',
  },
})(Link);

const NormalButton = styled.div`
  font-family: 'NSCJKrR';
  color: black;
  font-size: 18px;
  cursor: pointer;
  align-items: center;
`;

const ActiveButton = styled.div`
  /* font-family: "NSCJKrB"; */
  font-family: 'NSCJKrR';
  // color: #fe8b07;
  color: black;
  font-size: 18px;
  cursor: pointer;
  align-items: center;
`;


const subMenuList = styled.div`
  ${props =>
    props.visible
      ? css`
          display: block;
        `
      : css`
          display: none;
        `};
`;

export const subMenuListGroup = ({visible, children}) =>{
  return (
    <>
    <subMenuList visible= {visible}> {children}</subMenuList>
    </>

  )
}


export const TopBarItem = forwardRef(({ title, active = false, bold = false, trans = null, extm = true, children, ...props }, ref) => {
  const t = trans;
  return (
    <div style={{ position: 'relative' }} ref={ref}>
      <MediaQuery min={1611}>
        <CusLink {...props} style={{ paddingLeft: t && title === t('sign_in') ? 0 : 25 }}>
          {active ? 
            (bold ? <ActiveButton style={{color: "#fe8b07", fontWeight:'bold'}}>{title}</ActiveButton> :
                    <ActiveButton style={{color: "#fe8b07", }}>{title}</ActiveButton>
          
          ): (bold ? <NormalButton style={{fontWeight:'bold'}}>{title}</NormalButton> : 
              <NormalButton>{title}</NormalButton>
              )
          }
          {extm && (
            <div
              style={{
                backgroundImage: `url(${active ? images.expandmore_act : images.expandmore_nor})`,
                width: 13,
                height: 13,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                marginLeft: 12,
              }}
            />
          )}
        </CusLink>
      </MediaQuery>
      <MediaQuery max={1610}>
        <CusLinkMedium {...props} style={{ paddingLeft: t && title === t('sign_in') ? 0 : 25 }} >
            {active ? 
              (bold ? <ActiveButton style={{color: "#fe8b07", fontWeight:'bold'}}>{title}</ActiveButton> :
                      <ActiveButton style={{color: "#fe8b07", }}>{title}</ActiveButton>
            
            ): (bold ? <NormalButton style={{fontWeight:'bold'}}>{title}</NormalButton> : 
                <NormalButton>{title}</NormalButton>
                )
            }
            {extm && (
              <div
                style={{
                  backgroundImage: `url(${active ? images.expandmore_act : images.expandmore_nor})`,
                  width: 13,
                  height: 13,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  marginLeft: 12,
                }}
              />
            )}
          </CusLinkMedium>

      </MediaQuery>
      
      {children}
    </div>
  );
});
/* {active && (<div style={{ position: "absolute", left: 0, top:30, backgroundColor: 'white', border: '1px solid #eeeeee', width:'max-content',zIndex:99 }}>
        <div style={{ margin: '0px 20px', zIndex:99 }}>
          <LangItem style={{color:'black'}} >Textile Design Bank 서비스 소개</LangItem>
        </div>
      </div>)} */

const GnbListItem = withStyles({
  root: {
    paddingLeft: 30,
    paddingRight: 30,
    height: 60,
    minWidth: 260,
  },
})(ListItem);

const GnbListGroup = withStyles({
  root: {
    paddingLeft: 30,
    paddingRight: 30,
    height: 50,
  },
})(ListItem);

const GnbListText = withStyles({
  primary: {
    fontFamily: 'NSCJKrR',
    fontSize: 16,
    color: 'black',
    wordBreak: 'keep-all',
    fontWeight: 'bold',
    textAlign: 'left', // 왼쪽 정렬 추가
  },
})(ListItemText);

const GnbListTextRight = withStyles({
  primary: {
    fontFamily: 'NSCJKrR',
    fontSize: 16,
    color: 'black',
    wordBreak: 'keep-all',
    fontWeight: 'bold',
    marginLeft: 15,
    textAlign: 'right', // 오른쪽 정렬 추가
  },
})(ListItemText);

const GnbListTextVer2 = withStyles({
  primary: {
    fontFamily: 'NSCJKrR',
    fontSize: 16,
    color: '#6A6A6A',
    wordBreak: 'keep-all',
  },
})(ListItemText);


const GnbListTextVer4 = withStyles({
  primary: {
    display:'flex',
    flexDirection:'row',
    justifyContent:'flex-end',

    fontFamily: 'NSCJKrR',
    fontSize: 16,
    color: '#6A6A6A',
    wordBreak: 'keep-all',
  },
})(ListItemText);


const GnbListTextVer6 = withStyles({
  primary: {
    display:'flex',
    flexDirection:'row',
    justifyContent:'flex-end',

    fontFamily: 'NSCJKrR',
    fontSize: 18,
    color: 'black',
    wordBreak: 'keep-all',
  },
})(ListItemText);

const GnbListCenterText = withStyles({
  primary: {
    fontFamily: 'NSCJKrR',
    fontSize: 18,
    color: 'black',
    textAlign: 'center',
  },
})(ListItemText);


export const GnbExpoMenu = ({ title, imgVisible, ...props }) => {
  return (
    <GnbListItem {...props}>
      <GnbListText primary={title} />
      {title === "AI 디자인 제작 서비스" || title ===  "AI DESIGN GENERATOR" || title ===  "미국 저작권 등록 AI 서비스" || title ===  "AI U.S. COPYRIGHT SERVICE" ? 
       <div style={{
          display: 'flex',
          borderRadius: 100,
          backgroundColor: "#fe8b07",
          color: 'white',
          fontSize: 10,
          fontFamily: 'NSCJKrM',
          paddingLeft: 5,
          paddingRight: 5,
          paddingBottom: 2,
          margin: '0px 5px',
          lineHeight: '18px',}}>
            New
        </div>: 
        null
      }
      {/* 화살표 이미지 */}
      {imgVisible ? <img alt="" src={images.gnb_submenu} style={{ width: 8, height: 'auto', marginLeft:8 }} /> : null}
    </GnbListItem>
  );
};

export const GnbExpoMenuVer2 = ({ title, ...props }) => {
  return (
    <GnbListItem {...props}>
      <GnbListTextVer2 primary={title} />
      <img alt="" src={images.gnb_submenu} style={{ width: 8, height: 'auto', filter: 'grayscale(100%)' }} />
    </GnbListItem>
  );
};

export const GnbExpoMenuVer3 = ({ title, imgVisible, dropState, onClick,...props }) => {

  const [expanded, setExpanded] = useState(false);

  const handleTouchStart = () =>{
    setExpanded(prevExpanded => !prevExpanded);
    if(onClick){
      onClick();
    }
  }
  return (
    <GnbListItem onClick={handleTouchStart} {...props}>
      {imgVisible ? <img alt="" src={dropState ? images.expandmore_up :images.expandmore_nor } style={{ width: 12, height: 6, marginTop:5 }} /> : null}
      <GnbListTextRight primary={title} />
    </GnbListItem>
  );
};

export const GnbExpoMenuVerSeller = ({ title, imgVisible, dropState, onClick,...props }) => {
  console.log(dropState);
  
  const [expanded, setExpanded] = useState(false);

  const handleTouchStart = () =>{
    setExpanded(prevExpanded => !prevExpanded);
    if(onClick){
      onClick();
    }
  }
  return (
    <GnbListItem onClick={handleTouchStart} {...props}>
      {imgVisible ? <img alt="" src={dropState ? images.expandmore_up :images.expandmore_nor } style={{ width: 12, height: 6, marginTop:5 }} /> : null}
      <GnbListTextRight primary={title} />
    </GnbListItem>
  );
};

export const GnbExpoMenuVer4 = ({ title, count, ...props }) => {
  return (
    <GnbListItem {...props}>
      <CartCountBadge count={count} style='badegV2'>                    
      </CartCountBadge>
      <GnbListTextVer4 primary={title} />
    </GnbListItem>
  );
};

export const GnbExpoMenuVer5 = ({ title, ...props }) => {
  return (
    <GnbListItem {...props}>
      <GnbListText primary={title} />
      <img alt="" src={images.logout} style={{ width: 30, height: 'auto', marginRight: 0 }} />
    </GnbListItem>
  );
};

export const GnbExpoMenuVer6 = ({ title, count, ...props }) => {
  return (
    <GnbListItem {...props}>
      <CartCountBadge count={count} style='badegV2'>                    
      </CartCountBadge>
      <GnbListTextVer6 primary={title} />
    </GnbListItem>
  );
};


export const GnbPrevMenu = ({ title, ...props }) => {
  return (
    <GnbListItem {...props}>
      <img alt="" src={images.gnb_prevmenu} style={{ width: 8, height: 'auto', marginRight: 20 }} />
      <GnbListText primary={title} />
    </GnbListItem>
  );
};

export const GnbMenuItem = ({ title, ...props }) => {
  return (
    <GnbListItem {...props}>
      <GnbListText primary={title} />
    </GnbListItem>
  );
};
export const GnbMenuItemVer2 = ({ title, onClick,...props }) => {

  return (
    <GnbListItem {...props}>
      <GnbListTextVer2 primary={title} onClick={onClick} />
    </GnbListItem>
  );
};

export const GnbMenuItemVer3 = ({ title, ...props }) => {
  return (
    <GnbListItem {...props}>
      <GnbListTextVer2 primary={title} />
    </GnbListItem>
  );
};
export const GnbMenuItemVer4 = ({ title, ...props }) => {
  return (
    <GnbListItem {...props}>
      <GnbListTextVer4 primary={title} />
    </GnbListItem>
  );
};
export const GnbMenuCenterItem = ({ title, ...props }) => {
  return (
    <GnbListItem {...props}>
      <GnbListCenterText primary={title} />
    </GnbListItem>
  );
};


const expendIcon = {
  paddingLeft: 12,
};

export const GnbMenuGroup = ({ title, ...props }) => {
  return (
    <GnbListGroup disabled={true} {...props}>
      <GnbListText primary={title} />
    </GnbListGroup>
  );
};
